import React, {useState,useEffect,useCallback} from 'react';
import styled from '@emotion/styled'
import { animateScroll as scroll } from 'react-scroll';
import * as breakpoint from '../../styles/breakpoints.module.scss';

const TopBtn = () => {

  const [ isBottom, setIsBottom ] = useState(false);

  let updateScroll = useCallback((e) => {
    if(document && window.innerHeight + window.scrollY > document.getElementsByTagName('footer')[0].offsetTop)
    {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }

  },[setIsBottom]);

  useEffect(() => {
    window.addEventListener('scroll', updateScroll);

    return function cleanup() {
      window.removeEventListener('scroll', updateScroll);
    };
  });

  return(
    <Button className={isBottom ? 'isBottom' : ''} onClick={() => {
      scroll.scrollToTop();
    }}></Button>
  );

}

export default TopBtn;

const Button = styled.a`
position:fixed;
z-index:50;
bottom:40px;
right:40px;

width: 48px;
height: 48px;
background: #FFFFFF;

box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
border-radius: 24px;
cursor:pointer;


&:after{
  content:' ';
  position:absolute;
  top:50%;
  left:50%;
  width:13px;
  height:13px;
  border-top:2px solid #000000;
  border-left:2px solid #000000;

  transform: translate(-50%,-50%) rotate(45deg);
  margin-top: 3px;
}

&.isBottom{
  position:absolute;
}
@media only screen and (max-width: ${breakpoint.smMax}){
  bottom:16px;
  right:16px;
}

@media only screen and (max-width: ${breakpoint.xsMax}){
  right:auto;
  left:50%;
  transform:translateX(-50%);
  bottom:24px;
  position:absolute;
}

`
